import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
import { trackProductClick } from './MetaPixel';
export const GuaranteeSection = () => {
  return <section className="mb-10" data-id="element-15">
      <div className="bg-white p-6 border border-gray-200 rounded-lg" data-id="element-16">
        <h2 className="text-3xl font-bold text-blue-800 mb-4" data-id="element-17">
          Your 60-night risk-free opportunity to reclaim your mornings
        </h2>
        <p className="mb-4 text-gray-700 text-lg" data-id="element-18">
          Here's what separates Relievana™ from every other solution you've
          tried:
        </p>
        <div className="flex flex-col md:flex-row gap-6 mb-6" data-id="element-19">
          <div className="md:w-1/2" data-id="element-20">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9RkJ2orpBgF8Dh8is91mP1/badges.jpg" alt="Mother and daughter with Relievana pillow and guarantee badges" className="rounded-lg w-full h-auto object-contain" data-id="element-21" />
          </div>
          <div className="md:w-1/2" data-id="element-22">
            <p className="mb-4 text-gray-700 font-bold text-lg" data-id="element-23">
              They're so confident it will transform your sleep and eliminate
              your pain that they offer an unprecedented 60-night trial.
            </p>
            <p className="mb-4 text-gray-700 text-lg" data-id="element-24">
              That's two full months to experience the difference proper spinal
              alignment can make. If you don't wake up feeling more refreshed,
              more mobile, and significantly less pain, return it for a complete
              refund.
            </p>
            <p className="mb-4 text-gray-700 text-lg" data-id="element-25">
              No questions asked. No restocking fees. They even cover return
              shipping.
            </p>
            <p className="mb-4 text-gray-700 font-bold text-lg" data-id="element-26">
              But here's the special opportunity available right now:
            </p>
          </div>
        </div>
        <div className="bg-yellow-50 p-6 rounded-lg border border-yellow-200 mb-6" data-id="element-27">
          <p className="text-center mb-4 text-gray-700 text-lg" data-id="element-28">
            Click the button below and you'll be taken to Relievana™'s official
            website where a limited-time offer of 40% OFF is automatically
            applied to your order.
          </p>
          <p className="text-center mb-6 text-gray-700 font-bold text-lg" data-id="element-29">
            This offer won't last long – demand has been overwhelming since word
            spread about these results, and they're struggling to keep up with
            orders.
          </p>
          <a href="https://relievana.com/products/relievana%E2%84%A2-alignment-pillow" className="bg-green-600 hover:bg-green-700 text-white py-4 px-8 rounded-lg font-bold flex items-center justify-center mx-auto transition-colors text-xl" onClick={trackProductClick} data-id="element-30">
            GET YOUR RELIEVANA™ PILLOW - 40% OFF TODAY
            <ChevronRightIcon className="ml-2" size={24} data-id="element-31" />
          </a>
        </div>
        <div className="mb-6" data-id="element-32">
          <p className="mb-3 text-gray-700 text-lg" data-id="element-33">
            Don't let another morning start with that familiar shooting pain.
          </p>
          <p className="mb-3 text-gray-700 text-lg" data-id="element-34">
            Don't spend another day watching life pass by from the sidelines.
          </p>
          <p className="mb-3 text-gray-700 text-lg" data-id="element-35">
            Don't accept "chronic pain is your new normal" when the solution to
            breaking this cycle is literally one click away.
          </p>
        </div>
        <p className="mb-4 text-gray-700 text-lg" data-id="element-36">
          Your spine has been fighting this battle for too long. Your nerves
          have been crying out for relief. Your body has been begging for proper
          alignment.
        </p>
        <p className="mb-4 text-gray-700 font-bold text-lg" data-id="element-37">
          Tonight could be the first night of your transformation.
        </p>
        <p className="mb-6 text-gray-700 text-lg" data-id="element-38">
          The same precision engineering that helped me reclaim my life is ready
          to work for you. The only question is: Are you ready to finally end
          your pillow saga and step into pain-free mornings?
        </p>
        <a href="https://relievana.com/products/relievana%E2%84%A2-alignment-pillow" className="bg-green-600 hover:bg-green-700 text-white py-4 px-8 rounded-lg font-bold flex items-center justify-center w-full transition-colors mb-8 text-xl" onClick={trackProductClick} data-id="element-39">
          GET YOUR RELIEVANA™ PILLOW - 40% OFF TODAY
          <ChevronRightIcon className="ml-2" size={24} data-id="element-40" />
        </a>
        <div className="text-center text-gray-500 border-t border-gray-200 pt-6" data-id="element-41">
          <p className="mb-2 text-base" data-id="element-42">
            60-Night Risk-Free Trial | Free Shipping Both Ways
          </p>
          <p className="mt-6 text-sm" data-id="element-43">
            This is an advertisement and not a medical endorsement. Individual
            results may vary. The Relievana™ pillow is not intended to
            diagnose, treat, cure, or prevent any medical condition. Consult
            your healthcare provider before making changes to your pain
            management routine. This product has not been evaluated by the FDA.
          </p>
        </div>
      </div>
    </section>;
};